import dayjs from 'dayjs';

const MONTH_FORMAT = 'YYYY-MM';
const MONTH_REGEX = /^\d{4}-(0[1-9]|1[0-2])$/;

const isValidMonth = (value: unknown): value is string => typeof value === 'string' && MONTH_REGEX.test(value);

/** Current calendar month relative to `now`, formatted as 'YYYY-MM'. */
export const getDefaultMonth = (now: dayjs.Dayjs): string => now.format(MONTH_FORMAT);

/**
 * Reads the `month` param (accepts a URLSearchParams instance or a plain params
 * object, e.g. the result of `getPageParams()`). Falls back to the current
 * calendar month when the param is missing or not a valid 'YYYY-MM' string.
 */
export const getMonthParam = (params: URLSearchParams | Record<string, unknown>): string => {
  const raw = params instanceof URLSearchParams ? params.get('month') : params.month;

  if (isValidMonth(raw)) {
    return raw;
  }

  return getDefaultMonth(dayjs());
};

/** Formats a 'YYYY-MM' string as e.g. 'June 2026'. */
export const formatMonthLabel = (month: string): string => dayjs(month).format('MMMM YYYY');

/** Shifts a 'YYYY-MM' string by one month forward (1) or backward (-1). */
export const shiftMonth = (month: string, delta: 1 | -1): string =>
  dayjs(month).add(delta, 'month').format(MONTH_FORMAT);
